import ProductStatementReportItem  from '@/store/entities/product-statement-report-item';

export default class ProductStatementReportOutput {
    sku:string;
    productId:number;
    productName :string;
    assetTypeName : string;
    conditionTypeName :string;
    clientName :string;
    warehouseName : string;
    beginningBalanceQty :number;
    endingBalanceQty :number;
    items : Array<ProductStatementReportItem>;
   
}